import orderCustomForm from '@/api/order_custom_form'

export default ({ commit }) => {
  return new Promise((resolve, reject) => {
    orderCustomForm.getOrderCustomForm(result => {
      commit('setOrderCustomForm', result.data.data)
      resolve(result.data.data)
    })
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/order_custom_form/actions/getOrderCustomForm.js